module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAMFBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8v///8QbGAlAAAADnRSTlMAyyT0741Pt64zMOWOSHHlpe8AAABySURBVAjXYwCCpdLWogsYwEDjHRC8UAAxef3egYAviJ33DgISGBiY7KBsIwYG9ndQ8JyBYd47GJjAcA7ODmCQg7MFGPbB2Q4MQOL9////gdQDBj842wFZPbI5KOYj7EV2D6o7GdggEmao/gL7V+QJ2L8AaaWZibPwwTIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_cancel.png
// module id = zlYk
// module chunks = 9